import { ApiError } from '@pxtra-client-lib-legacy/gen';
import { useQuery } from '@tanstack/react-query';
import { apiClient } from '../../lib/util';

export const useExportPreferences = (
  companyId: string | undefined,
  exportType: string | undefined
) => {
  return useQuery({
    queryKey: ['exportPreferences', companyId, exportType],
    queryFn: async () => {
      try {
        return await apiClient.impex.impexExportLatestPreferencesRetrieve({
          company: companyId!,
          exportType: exportType!
        });
      } catch (error) {
        if (error instanceof ApiError && error.status === 404) {
          return null;
        }
        throw error;
      }
    },
    enabled: !!companyId && !!exportType,
    staleTime: 0
  });
};
